export default __webpack_public_path__ + "static/media/condition_res.de508a6a.PNG";